export default function SiteFooter() {
  return (
    <footer className="border-t border-background-200 bg-secondary-100/70">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6">
        <div className="flex flex-col items-start justify-between gap-6 sm:flex-row sm:items-center">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="grid place-items-center w-8 h-8 rounded-md bg-primary-500 text-background-50 text-sm font-bold">黑</span>
              <span className="font-heading text-base font-black tracking-tight text-foreground-950">
                抖音<span className="text-primary-600">黑料</span>
              </span>
            </div>
            <p className="mt-3 max-w-sm text-xs leading-6 text-foreground-600">
              抖音千万粉大网红黑历史与头部主播翻车旧账的专题合集。按人物分批整理，谁有瓜先点谁，新料持续补进同一篇。
            </p>
          </div>

          <div className="flex items-center gap-2">
            {["话题墙", "人物档案", "热评走廊", "编辑手记"].map((label, i) => (
              <a
                key={label}
                href={`#${["topics", "dossier", "comments", "note"][i]}`}
                className="whitespace-nowrap rounded-full bg-background-50 px-4 py-2 text-xs text-foreground-700 transition-colors hover:text-foreground-950 cursor-pointer"
              >
                {label}
              </a>
            ))}
          </div>
        </div>

        <div className="mt-8 flex flex-col items-start justify-between gap-3 border-t border-background-200/70 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center">
          <p>© 2026 抖音黑料 · 静态专题展示页</p>
          <p className="inline-flex items-center gap-1.5">
            <i className="ri-shield-check-line text-sm leading-none" />
            人物与内容均为排版示意，仅供版式浏览
          </p>
        </div>
      </div>
    </footer>
  );
}